const tr = {
  packageEspecialtyActives: {
    attributes: {
      id: 'ID',
      name: 'Nome',
      cpf: 'CPF',
      cell_phone: 'Telefone',
      email: 'E-mail',
      corporation: 'Empresa',
      specialty: 'Especialidade',
    },
    extras: {
      date_init: 'Data inicial',
      date_end: 'Data final',
      search: 'Digite o nome ou CPF',
      considerBranches: 'Considerar filiais',
      considerAllBranches: 'Considerar todas filiais',
      consider: 'Considerar',
      specialty: 'Especialidade',
    },
    defSingular: 'Relatório de adicionais especialistas ativos por empresa',
  },
};

export default tr;
